import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

type SearchOrchidProParams = {
  state?: string;
  zipcode?: string;
  orchid_pro_name?: string;
  search_term?: string;
  available_before?: string;
  skip?: number;
  limit?: number;
  specialty?: string;
};
export default async function searchOrchidPro(
  { skip = 0, limit = 20, ...params }: SearchOrchidProParams,
  fetchOptions?: Omit<RequestInit, "method">,
): Promise<{
  limit: number;
  results: OrchidPro[];
  skip: number;
  total_count: number;
  typeahead: string[];
}> {
  const res = await fetchOrchidAPI(
    "/api/users/v1/orchid_pro/search?" +
      `skip=${skip}&limit=${limit}` +
      Object.entries(params)
        .map(([key, value]) => (!value ? "" : `&${key}=${value}`))
        .join(""),
    { method: "POST", ...fetchOptions },
  );
  if (!res.ok) {
    throw new Error(
      `failed to search orchid pro: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
